export const playSound = (context, {
  frequency,
  gain,
  length,
  startAt,
  type = 'sine'
}) => {
  const startTimeInSeconds = startAt / 1000;
  const oscillator = context.createOscillator();
  const gainNode = context.createGain();
  oscillator.type = type;
  oscillator.frequency.value = frequency;
  const decayTime = 0.1;
  const baseGain = 0.3;
  gainNode.gain.value = gain * baseGain;
  gainNode.gain.setValueAtTime(gainNode.gain.value, context.currentTime + startTimeInSeconds);
  gainNode.gain.exponentialRampToValueAtTime(0.00001, context.currentTime + startTimeInSeconds + length - decayTime);
  oscillator.start(context.currentTime + startTimeInSeconds);
  oscillator.stop(context.currentTime + startTimeInSeconds + length);
  oscillator.connect(gainNode);
  gainNode.connect(context.destination);
  return () => {
    oscillator.stop();
  };
};